/*
 *  TileFormat represents different tile formats for content assets.
 */
enum TileFormat {
  VOD = "VOD",
  ContinueWatching = "ContinueWatching",
  Upcoming = "Upcoming",
  Live = "Live",
  Replay = "Replay",
  Channels = "Channels",
  Playlist = "Playlist",
  Collection = "Collection",
  Hub = "Hub",
  Clip = "Clip",
}

export { TileFormat };
